/**
 * Converts an object of key value pairs into
 * FormData parameters
 */
export const convertToFormData = (params: Object) => {
  const formData = new FormData();
  if (!params) return formData;

  const keyValuePairs = Object.entries(params);
  if (keyValuePairs.length === 0) return formData;

  keyValuePairs.forEach(([key, value]) => {
    formData.append(key, value);
  });

  return formData;
};
